export default {
  freePlanWelcome: {
    title: "Welcome to Invup",
    planLine: "You're on the Free plan \u2014 start invoicing right away.",
    bulletsHeading: "What's included",
    bulletInvoicing: "Create and send invoices with your branding",
    bulletPayments: "Collect payments through Stripe",
    bulletHistory: "Track every invoice, client, and payment",
    bulletLimit:
      "Up to 1 team member and monthly caps on invoices, forms, and time entries",
    upsellHeading: "Ready to go further?",
    upsellBody:
      "Upgrade to Pro for unlimited team members, recurring invoices, custom fields, and higher monthly limits.",
    upgradeCta: "See Pro plans",
    dismissCta: "Got it, thanks",
  },
  billing: "Billing",
  usage: "Usage",
  plans: "Plans",
  addOnsTab: "Add-ons",
  history: "Receipts",
  settings: "Settings",
  history_: {
    title: "Billing history",
    description: "Past subscription invoices and receipts.",
    period: "Period",
    base: "Base",
    seats: "Seats",
    addOns: "Add-ons",
    overages: "Overages",
    total: "Total",
    status: "Status",
    paidAt: "Paid",
    noInvoices: "No invoices yet.",
    detailTitle: "Invoice {{code}}",
    detailPeriod: "Billing period: {{start}} – {{end}}",
    lineItemsHeading: "Line items",
    closeDetail: "Close",
    statusPaid: "Paid",
    statusPending: "Pending",
    statusFailed: "Failed",
  },
  addOnsSection: {
    title: "Add-ons",
    description:
      "Optional extras that layer on top of your Pro plan. Each is billed monthly alongside your cycle.",
    activate: "Activate",
    activating: "Activating\u2026",
    deactivate: "Deactivate",
    deactivating: "Deactivating\u2026",
    activeBadge: "Active",
    cancelScheduledBadge: "Cancelling {{date}}",
    proOnlyTitle: "Available on Pro",
    proOnlyBody: "Upgrade to Pro to activate add-ons.",
    viewPlans: "View plans",
    monthlyPrice: "{{amount}}/mo",
    confirmActivateTitle: "Activate {{name}}?",
    confirmActivateBody:
      "You'll be charged a prorated {{amount}} now for the remainder of this cycle. After that, {{full}} will be added to your regular monthly billing.",
    confirmActivateBodyNoProration:
      "A prorated charge for the remainder of this cycle is applied now, then {{full}} is billed with your normal cycle.",
    confirmActivateCta: "Activate",
    confirmDeactivateTitle: "Deactivate {{name}}?",
    confirmDeactivateBody:
      "Your add-on stays active until {{date}} (end of the current cycle) with no refund for the paid-through period. It will not be billed on the next cycle.",
    confirmDeactivateCta: "Schedule cancellation",
    cancel: "Cancel",
    activated: "{{name}} activated.",
    deactivated: "{{name}} cancellation scheduled.",
  },
  overageSettings: {
    title: "Overage billing",
    description:
      "Overage billing lets you keep creating past your plan's limits. Any extra usage is billed at the end of the cycle at the overage rates shown on your plan.",
    toggleLabel: "Enable overage billing",
    capLabel: "Monthly spending cap",
    capHelp:
      "Cap the total amount we can bill you for overages this cycle. Leave blank for no cap.",
    capPlaceholder: "e.g. 50.00",
    save: "Save overage settings",
    saving: "Saving\u2026",
    saved: "Overage settings saved.",
    proOnly:
      "Overage billing is only available on the Pro plan. Upgrade to enable it.",
  },
  paymentMethod: {
    title: "Payment method",
    description: "Used for Pro plan subscription charges and overage billing.",
    noCard: "No card on file.",
    addCard: "Add a card",
    updateCard: "Update card",
    removeCard: "Remove card",
    removeBlocked:
      "You can't remove your card while on an active Pro plan. Downgrade first.",
    brandExpires:
      "{{brand}} \u2022\u2022\u2022\u2022 {{last4}} \u00b7 exp {{month}}/{{year}}",
    confirmRemoveTitle: "Remove payment method",
    confirmRemoveBody:
      "You won't be able to upgrade or be billed for overages until you add a new card.",
    confirmRemoveCta: "Remove card",
    cancel: "Cancel",
    removed: "Card removed.",
    saved: "Card saved.",
    cardUpdated: "Card updated.",
  },
  usageDashboard: {
    title: "Usage this cycle",
    description:
      "Track how much of your plan's allowance you've used in the current billing cycle.",
    cycleRange: "{{start}} – {{end}}",
    noCycle: "No active billing cycle",
    noSubscription: "No subscription found",
    features: {
      invoices: "Invoices",
      form_submissions: "Form submissions",
      time_entries: "Time entries",
    },
    usageOf: "{{count}} of {{limit}}",
    usageUnlimited: "{{count}} used",
    percentage: "{{pct}}%",
    overageCount: "{{count}} over limit",
    overageCost: "Overage today: {{amount}}",
    overageDisabled: "Overage billing off",
    manageOverage: "Manage overage billing",
    enableOverage: "Enable overage billing",
  },
  approachingLimit: {
    title: "You're close to the limit",
    body: "You've used {{count}} of {{limit}} {{feature}} this cycle ({{pct}}%).",
    overageBody:
      "You've used {{count}} of {{limit}} {{feature}} this cycle ({{pct}}%). Overage billing is enabled — any extra usage will be billed at the end of the cycle.",
    upgradeCta: "View plans",
    dashboardCta: "See usage",
  },
  limitReached: {
    title: "You've hit your {{feature}} limit",
    bodyFree:
      "You've used {{current}} of {{limit}} {{feature}} this cycle. Upgrade to Pro for higher limits and overage billing.",
    bodyProNoOverage:
      "You've used {{current}} of {{limit}} {{feature}} this cycle. Enable overage billing to keep going — any extra usage is billed at the end of the cycle.",
    bodyProSpendingCap:
      "You've reached your overage spending cap for this cycle. Raise the cap to keep creating {{feature}}.",
    upgradeCta: "Upgrade to Pro",
    enableOverageCta: "Enable overage billing",
    manageCapCta: "Manage spending cap",
    close: "Close",
  },
  currentPlan: "Current plan",
  comparePlans: "Compare plans",
  legacyPlan: "Legacy (grandfathered)",
  legacyNote:
    "You're on a grandfathered plan with special pricing. Upgrading to Pro switches you to the current Pro pricing.",
  upgradeToPro: "Upgrade to Pro",
  alreadyOnPro: "You're on Pro",
  selectToCompare: "Select to compare",
  basePrice: "Base price",
  seatPrice: "per additional seat",
  perMonth: "/mo",
  includedFeatures: "Included features",
  unlimited: "Unlimited",
  downgradeLink: "Downgrade to Free",
  downgradeScheduledBanner:
    "Your plan will change to Free on {{date}}. You'll continue to have Pro access until then.",
  downgradeScheduledShort: "Downgrade scheduled for {{date}}",
  cancelDowngrade: "Cancel downgrade",
  downgradeCancelled: "Scheduled downgrade cancelled. You're staying on Pro.",
  downgradeFlow: {
    title: "Downgrade to Free",
    description:
      "Review what changes when your plan switches to Free. Your downgrade will take effect at the end of your current billing cycle.",
    scheduledFor:
      "Your plan will change to Free at the end of your current billing cycle on {{date}}.",
    impactHeading: "What changes",
    membersHeading: "Team members",
    membersCount_one: "{{count}} team member will be deactivated:",
    membersCount_other: "{{count}} team members will be deactivated:",
    membersNone: "No team members will be affected.",
    addOnsHeading: "Active add-ons",
    addOnsCount_one: "{{count}} add-on will be cancelled:",
    addOnsCount_other: "{{count}} add-ons will be cancelled:",
    addOnsNone: "No add-ons are active.",
    recurringHeading: "Recurring invoices",
    recurringCount_one: "{{count}} recurring invoice will be paused.",
    recurringCount_other: "{{count}} recurring invoices will be paused.",
    recurringNone: "No recurring invoices are active.",
    recurringNote:
      "You'll need to manually re-enable these if you re-upgrade to Pro.",
    customFieldsHeading: "Custom fields",
    customFieldsCount_one: "{{count}} custom field will be hidden.",
    customFieldsCount_other: "{{count}} custom fields will be hidden.",
    customFieldsNone: "No custom fields are configured.",
    customFieldsNote:
      "Custom field data is preserved and becomes visible again if you re-upgrade.",
    retentionHeading: "Data retention",
    retentionWarning:
      "After the downgrade, data older than {{hide}} days will be hidden, and data older than {{purge}} days will be permanently deleted.",
    retentionImpact:
      "Affected today: {{hide}} record(s) would be hidden, {{purge}} record(s) would be permanently deleted.",
    confirmPrompt: "To confirm, type DOWNGRADE in the box below.",
    confirmPlaceholder: "Type DOWNGRADE",
    cancel: "Cancel",
    scheduleDowngrade: "Schedule downgrade",
    scheduling: "Scheduling…",
    successTitle: "Downgrade scheduled",
    successDescription:
      "Your downgrade to Free has been scheduled for {{date}}. You'll continue to have Pro access until then.",
    finish: "Got it",
    genericError: "Something went wrong. Please try again.",
  },
  upgradeFlow: {
    confirmPlan: "Confirm your upgrade",
    confirmPlanDescription:
      "Review what you'll get on the Pro plan before entering payment details.",
    paymentMethod: "Payment method",
    paymentMethodDescription:
      "Enter a card to bill your Pro subscription. Your card is stored securely with Stripe.",
    review: "Review and confirm",
    reviewDescription:
      "Here's what you'll be charged today for your first Pro cycle.",
    success: "Welcome to Pro",
    successDescription:
      "Your organization has been upgraded. You now have access to all Pro features.",
    chargeBreakdown: "Charge breakdown",
    basePlan: "Base plan",
    seats: "Seats ({{count}})",
    addOns: "Add-ons",
    total: "Total due today",
    billingPeriod: "Billing period",
    continue: "Continue",
    back: "Back",
    cancel: "Cancel",
    savingCard: "Saving card…",
    upgrading: "Upgrading…",
    confirmUpgrade: "Confirm upgrade",
    finish: "Finish",
    paymentFailed:
      "Payment failed: {{message}}. Please check your card details and try again.",
    genericError: "Something went wrong. Please try again.",
    cardDeclined: "Your card was declined.",
    tryAgain: "Try again",
  },
};
